<ng-container *ngIf="item.children; else noSubDrop">
  <a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">{{ item.label }}
    <span class="caret"></span>
  </a>
  <ul class="dropdown-menu sub-drop" role="menu">
    <li *ngFor="let subItem of item.children" [class.dropdown-submenu]="subItem.children">
      <ng-container *ngIf="subItem.children; else noSubSubDrop">
        <a href="#" class="sub-start">{{ subItem.label }}
          <span class="caret"></span>
        </a>
        <ul class="dropdown-menu sub-sub-drop">
          <li *ngFor="let subSubItem of subItem.children">
            <a [routerLink]="subSubItem.routerLink" (click)="subSubItem.command ? subSubItem.command($event, subSubItem) : false">{{ subSubItem.label }}</a>
          </li>
        </ul>
      </ng-container>
      <ng-template #noSubSubDrop>
        <a [routerLink]="subItem.routerLink" (click)="subItem.command ? subItem.command($event, subItem) : false">{{ subItem.label }}</a>
      </ng-template>
    </li>
  </ul>
</ng-container>
<ng-template #noSubDrop>
  <a [routerLink]="item.routerLink" (click)="item.command ? item.command($event, item) : false">{{ item.label }}</a>
</ng-template>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵbm.html